<template>
  <div id="majors" @click="searching=false">
    <div id="landing-hero" class="ds-main ds-background" :class="{'is-unm': $store.getters.isUnmMain}">
      <div id="landing">
        <h1>Find Your Degree</h1>
        <h2>Explore our many programs of study to find the one that best fits you.</h2>

        <div id="search-links">
          <div class="search-link-column">
            <router-link
              :to="{name: 'nameSearch'}"
              class="ds-main ds-color-hover search-link"
            >
              All Programs
            </router-link>
          </div>

          <div class="search-link-column keyword-search" @click.stop="searching=true">
            <form
              v-if="searching"
              @submit.prevent="search"
            >
              <input type="text" ref="searchBox" v-model="searchKey" v-focus><!--
              --><button type="submit"><i class="fas fa-search"></i></button>
            </form>

            <a class="ds-main ds-color-hover search-link" v-else>
              <i class="fas fa-search"></i>
              Find by Keyword
            </a>
          </div>

          <div class="search-link-column">
            <router-link
              :to="{name: 'interestSearch'}"
              class="ds-main ds-color-hover search-link"
            >
              Search by Interest
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Landing',

    data() {
      return {
        searching: false,
        searchKey: ''
      }
    },

    methods: {
      search() {
        this.$router.push({
          name: 'nameSearch',
          query: {keyword: this.searchKey}
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Landing.vue?2bbfbada